import enLocale from 'element-ui/lib/locale/lang/en'
import home from './ph/home'

const ph = {
    language: 'English',
    message: {
        'home': {
            ...home,
            enterEmail: 'Mangyaring maglagay ng email',
            save: 'I-save',
            saveSuccess: 'Matagumpay na na-save',
            pointHistory: 'Kasaysayan ng puntos',
            type: 'Uri',
            remark: 'Tala',
            pendingComment: 'Nakabinbing review',
            commented: 'Na-review na',
            selectDate: 'Pumili ng petsa',
            loginSuccess: 'Matagumpay na pag-login',
            loginFail: 'Nabigo ang pag-login',
            close: 'Isara',
            required: 'Kinakailangan',
            nickname: 'Palayaw',
            enterNickname: 'Mangyaring maglagay ng palayaw',
            gender: 'Kasarian',
            male: 'Lalaki',
            female: 'Babae',
            secret: 'Lihim',
            birthday: 'Kaarawan',
            checkoutLoadFailed: 'Nabigo ang pag-load ng impormasyon sa pagbabayad. Pakisubukang muli mamaya.',
            checkoutErrorTitle: 'Paunawa',
            goAddAddress: 'Magdagdag ng address ng paghahatid',
            shop_order_selectOrAddAddress: 'Mangyaring magdagdag muna ng address ng paghahatid at itakda bilang default bago mag-checkout.',
            shop_order_cartEmpty: 'Walang laman ang cart, hindi makapag-checkout.',
            shop_order_cartHasNotActive: 'May mga produktong hindi nakalista o hindi wasto, hindi makapag-checkout.',
            shop_order_cartHasNotMarketable: 'May mga produktong inalis na, hindi makapag-checkout.',
            shop_order_cartHasLowStock: 'Kulang ang stock, hindi makapag-checkout.',
            shop_order_cartHasExpiredGoods: 'May ilang produkto ng tindahan na nag-expire na, hindi makapag-checkout.',
            shop_order_typeIsNull: 'Hindi makilala ang uri ng order, pakisuri ang uri ng produkto.',
            shop_order_goodsNotFound: 'Walang impormasyon ng produkto o natanggal na.',
            shop_order_giftNotForSale: 'Ang mga regalong produkto ay hindi maaaring bilhin nang direkta.',
            common_message_badRequest: 'Hindi wastong kahilingan, pakisuri ang produkto at mga parameter.',
        },
    },
    '手机号码最小长度为8位': "The minimum length of the mobile phone number is 8 digits.",
    '邮箱账号名称最小长度为6位': "The minimum length of the email account name is 6 characters.",
    '邮箱只能包含英文，数字等字符': "The Email can only contain English, numbers and other characters",
    '请选择正确的收货地址': "Please select the correct delivery address.",
    Dict_language_status_0: 'Naka-disable',
    Dict_language_status_1: 'Naka-enable',
    Dict_member_label_type_1: 'Label na may kondisyon',
    Dict_member_label_type_2: 'Manu-manong label',
    Dict_member_level_type_0: 'Antas ng konsumo (LV)',
    Dict_member_level_type_1: 'Bayad na miyembro (VIP)',
    Dict_member_growth_action_type_1: 'Mag-order',
    Dict_member_growth_action_type_2: 'Araw-araw na pag-login',
    Dict_member_growth_action_type_3: 'Mag-post ng review',
    Dict_member_growth_action_type_4: 'Kumpletuhin ang profile',
    Dict_paid_member_payment_type_0: 'Pagbabayad gamit ang balanse',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'Wasto',
    Dict_paid_member_record_status_1: 'Nag-expire',
    Dict_paid_member_record_status_2: 'Na-refund',
    Dict_point_lottery_prize_type_0: 'Puntos',
    Dict_point_lottery_prize_type_1: 'Kupon',
    Dict_point_lottery_prize_type_2: 'Pisikal na premyo',
    Dict_point_lottery_prize_type_3: 'Salamat sa pakikilahok',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: 'Email',
    Dict_notification_channel_type_2: 'Mensahe sa loob ng site',
    Dict_notification_channel_type_3: 'Push notification',
    Dict_announcement_status_0: 'Draft',
    Dict_announcement_status_1: 'Nai-publish',
    Dict_announcement_status_2: 'Inalis',
    Dict_live_permission_status_0: 'Hindi pa nag-apply',
    Dict_live_permission_status_1: 'Sinusuri',
    Dict_live_permission_status_2: 'Na-activate',
    Dict_live_permission_status_3: 'Tinanggihan',
    Dict_live_room_status_0: 'Hindi pa nagsisimula',
    Dict_live_room_status_1: 'Live',
    Dict_live_room_status_2: 'Tapos na',
    Dict_live_room_status_3: 'Abnormal na pagkaantala',
    Dict_live_room_type_0: 'Live ng platform',
    Dict_live_room_type_1: 'Live ng merchant',
    Dict_store_type_0: 'Indibidwal na tindahan',
    Dict_store_type_1: 'Tindahan ng kumpanya',
    Dict_store_sign_status_0: 'Naghihintay ng pirma',
    Dict_store_sign_status_1: 'Napirmahan',
    Dict_store_sign_status_2: 'Tinapos',
    Dict_store_business_change_status_0: 'Naghihintay ng pagsusuri',
    Dict_store_business_change_status_1: 'Inaprubahan',
    Dict_store_business_change_status_2: 'Tinanggihan',
    Dict_decoration_page_type_0: 'Home page',
    Dict_decoration_page_type_1: 'Pahina ng kategorya',
    Dict_decoration_page_type_2: 'Pahina ng kampanya',
    Dict_decoration_page_type_3: 'Custom na pahina',
    Dict_decoration_status_0: 'Draft',
    Dict_decoration_status_1: 'Nai-publish',
    Dict_decoration_popup_trigger_page_0: 'Home ng platform',
    Dict_decoration_popup_trigger_page_1: 'Member center',
    Dict_decoration_popup_trigger_page_2: 'Matagumpay na pagbabayad',
    Dict_decoration_popup_target_user_0: 'Lahat ng user',
    Dict_decoration_popup_target_user_1: 'Libreng miyembro',
    Dict_decoration_popup_target_user_2: 'Bayad na miyembro',
    Dict_decoration_popup_frequency_0: 'Isang beses nang permanente',
    Dict_decoration_popup_frequency_1: 'Bawat pagbisita',
    Dict_decoration_popup_frequency_2: 'Custom na dalas',
    Dict_track_event_type_page_view: 'Pagtingin sa pahina',
    Dict_track_event_type_click: 'I-click',
    Dict_track_event_type_add_to_cart: 'Idagdag sa cart',
    Dict_track_event_type_search: 'Maghanap',
    Dict_track_event_type_purchase: 'Bilhin',
    Dict_track_event_type_live_watch: 'Manood ng live',
    Dict_reconcile_period_type_0: 'Araw-araw',
    Dict_reconcile_period_type_1: 'Lingguhan',
    Dict_reconcile_period_type_2: 'Buwanan',
    Dict_store_settlement_status_0: 'Naghihintay ng settlement',
    Dict_store_settlement_status_1: 'Na-settle',
    Dict_distributor_status_0: 'Naghihintay ng pagsusuri',
    Dict_distributor_status_1: 'Nasuri',
    Dict_distributor_status_2: 'Tinanggihan',
    Dict_distribution_commission_type_0: 'Direktang komisyon',
    Dict_distribution_commission_type_1: 'Hindi direktang komisyon',
    Dict_configuration_status_0: 'Naka-disable',
    Dict_configuration_status_1: 'Naka-enable',
    ...enLocale
}

export default ph